// extracted by mini-css-extract-plugin
export default {"planTypeIconClassFirewallDaylight":"plan_types_planTypeIconClassFirewallDaylight__l9FEN","planTypeIconClassFirewallMidnight":"plan_types_planTypeIconClassFirewallMidnight__eLsQM"};